import React, {useState, useEffect} from 'react';
import styled from 'styled-components'

import TabContainer from '../TabContainer'

import List from './list/List'
import { fetchApi } from '../../api/fetchApi';
import CompanyBox from '../CompanyBox';
import User from './user/User'
import { listUsersApi } from '../../api/userApi';
import { deleteUserOfCompany } from '../../api/companyApi';
import ModalDelete from '../ModalDelete';

const UsersAdministration = ({height, company}) => {

  const [userList, setUserList] = useState([])
  const [userSelected, setUserSelected] = useState(null);
  const [userToRemove, setUserToRemove] = useState(null);


  useEffect(() => {
    if(company.id){
      reloadUserList()
    }
  }, [company.id])

  const reloadUserList = () => {
    listUsersApi(company.id)
    .then(response => {              
        setUserList(response.data);
    })
  }

  const selectUser = (perspective) => {
    setUserSelected(perspective);
  };

  const newUser = () => {
    setUserSelected({})
  }

  const deleteUser = (userId) => {
    deleteUserOfCompany(company.id, userId)
    .then((response) => {
        setUserToRemove(null);
        setUserList(userList.filter(user => user.id !== userId));
    })
    .catch(error => {
      // console.log('ERROR: ', error);
    });
  }

  const openModalDeleteUser = (user) => {
      setUserToRemove(user);
  }


    return (
        <TabContainer height={height}>
            <AdmMainContainer>

            <ModalDelete 
              show={userToRemove != null} 
              text={`Are you sure do you want remove the user ${userToRemove?.name.toUpperCase()}?`}
              cancel={() => setUserToRemove(null)}
              remove={() => deleteUser(userToRemove?.id)}
            />

            {userSelected ?
               <User 
                user={userSelected}
                company={company}
                selectUser={selectUser}
                reloadUserList={reloadUserList}
               />
                : 
                <List 
                items={userList}
                selectUser={selectUser}
                deleteUser={openModalDeleteUser}
                newUser={newUser}/>
              }
            </AdmMainContainer>
        </TabContainer>
    )


}

const AdmMainContainer = styled.div`
    display:flex;
    
    /* border:5px solid yellow; */

`

export default UsersAdministration;